export default {
    project_name: "Unifrete"
}